import { Query } from '../../../common/api/Query'
import { SendingStatus } from '../enums/SendingStatus'
import { TransportType } from '../../../common/enums/TransportType'
import { EventType } from '../enums/EventType'
import { Message } from './Message'

export type NotificationParams = {
  id?: string
  title: string
  message: string
  recipientID: string
  senderID: string
  deliveryStatus: SendingStatus
  createdAt: Date
  eventType: EventType
  transportType: TransportType
}

export class Notification {
  private readonly _id: string | undefined
  private readonly _title: string
  private readonly _message: string
  private readonly _recipientID: string
  private readonly _senderID: string
  private readonly _deliveryStatus: SendingStatus
  private readonly _createdAt: Date
  private readonly _transportType: TransportType
  private readonly _eventType: EventType

  constructor(p: NotificationParams) {
    this._id = p.id
    this._title = p.title
    this._message = p.message
    this._recipientID = p.recipientID
    this._senderID = p.senderID
    this._deliveryStatus = p.deliveryStatus
    this._createdAt = p.createdAt
    this._transportType = p.transportType
    this._eventType = p.eventType
  }

  get id(): string | undefined {
    return this._id
  }

  get title(): string {
    return this._title
  }

  get message(): string {
    return this._message
  }

  get recipientID(): string {
    return this._recipientID
  }

  get senderID(): string {
    return this._senderID
  }

  get deliveryStatus(): SendingStatus {
    return this._deliveryStatus
  }

  get createdAt(): Date {
    return this._createdAt
  }

  get transportType(): TransportType {
    return this._transportType
  }

  get eventType(): EventType {
    return this._eventType
  }
}

export class NotificationQuery extends Query<Message> {}
